import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeExtra'
})
export class TimeExtraPipe implements PipeTransform {
  transform(value: Date | string): string | null {
    const date = new Date(value);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}h${minutes}`;
  }
}
